import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config-service';
import {
  ChildApplicationDataDto,
  LaunchChildApplicationRequest,
  LaunchChildApplicationResponse,
  PendingChildLaunchInfo,
} from '../../models/application.model';

@Injectable()
export class ApplicationDataService {
  constructor(private http: HttpClient) {}

  configService = inject(ConfigService);

  async getSteps(appDataId: string): Promise<any> {
    const getUrl =
      this.configService.readConfig().baseUrlBusiness +
      `/appdata/GetById/${appDataId}`;

    var promise = this.http.get<any>(getUrl).pipe(map((appData) => appData));
    return await firstValueFrom(promise);
  }

  async setCurrentStep(appDataId: string, stepId: string) {
    const url =
      this.configService.readConfig().baseUrlBusiness +
      `/appdata/setCurrentStep?appId=${appDataId}&stepId=${stepId}`;
    const response = await firstValueFrom(
      this.http.get(url, { responseType: 'text' }),
    );
    return response;
  }

  getDataUrl(dataUrlId: string): Observable<any> {
    const url =
      this.configService.readConfig().baseUrlBusiness +
      `/DataURL/GetById/${dataUrlId}`;
    return this.http.get<any>(url);
  }

  launchChildApplication(
    request: LaunchChildApplicationRequest,
  ): Observable<LaunchChildApplicationResponse> {
    const url =
      this.configService.readConfig().baseUrlBusiness +
      '/appdata/LaunchChildApplication';
    return this.http.post<LaunchChildApplicationResponse>(url, request);
  }

  getChildApplications(
    parentAppDataUuid: string,
  ): Observable<ChildApplicationDataDto[]> {
    const url =
      this.configService.readConfig().baseUrlBusiness +
      `/appdata/GetChildren/${parentAppDataUuid}`;
    return this.http.get<ChildApplicationDataDto[]>(url);
  }

  getChildrenCounts(
    appDataIds: string[],
  ): Observable<{ [key: string]: number }> {
    const url =
      this.configService.readConfig().baseUrlBusiness +
      '/appdata/GetChildrenCounts';
    return this.http.post<{ [key: string]: number }>(url, { appDataIds });
  }

  getPendingChildLaunches(
    appDataIds: string[],
  ): Observable<{ [key: string]: PendingChildLaunchInfo }> {
    const url =
      this.configService.readConfig().baseUrlBusiness +
      '/appdata/GetPendingChildLaunches';
    return this.http.post<{ [key: string]: PendingChildLaunchInfo }>(url, {
      appDataIds,
    });
  }
}
